import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
// import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import 'react-modal-video/css/modal-video.min.css';
import './css/style.css';
import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';

// Add this import:
// import { AppContainer } from 'react-hot-loader';

// Wrap the rendering in a function:
// const render = Component => {
    ReactDOM.render(
      // Wrap App inside AppContainer
      // <AppContainer>
        <App />,
      // </AppContainer>,
      document.getElementById('root')
    );
  // };

//ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();

// render(App)

// Webpack Hot Module Replacement API
// if (module.hot) {
//     module.hot.accept('./components/App', () => {
//       render(App);
//     });
//   }


// WEBPACK FOOTER //
// ./src/index.js